import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { queryKeys } from '../../api/queryKeys';
import { firmSettingsAccessSelector } from '../../../../../AdviserArea/AdviserAreaSelector';
import { queryClient } from '../../../../../../config/queryClient';
import { queryKeys as modelsQueryKeys } from '../../../../../AdviserSettings/Page/Models/api/queryKeys';
import { openPopupWindow } from '../../utils/openPopupWindow';

let riskalyzeOauthInterval;

export const useRiskalyze = () => {
  const firmSettingsAccess = useSelector(firmSettingsAccessSelector);

  const connectRiskalyzeQuery = useQuery(
    queryKeys.riskalyze(),

    (): Promise<{ url: string }> => authFetch('/Adviser/Riskalyze/OAuthConnect'),
    {
      enabled: false,
    },
  );

  const { refetch: fetchRiskalyze } = connectRiskalyzeQuery;

  const importPortfoliosQueryInfo = useQuery(
    queryKeys.riskalyze('importPortfolios'),

    () => authFetch('/Adviser/Riskalyze/ImportPortfolios'),
    {
      enabled: false,
    },
  );

  const { refetch: fetchRiskalyzePortfolios } = importPortfoliosQueryInfo;

  useEffect(() => {
    return () => {
      clearInterval(riskalyzeOauthInterval);
    };
  }, []);

  const connectRiskalyze = async () => {
    try {
      const { data } = await fetchRiskalyze();

      const oAuthWindow = openPopupWindow(data?.url);

      const longPoolPopupWindow = async () => {
        if (!oAuthWindow || oAuthWindow.closed) {
          clearInterval(riskalyzeOauthInterval);
          riskalyzeOauthInterval = null;

          const { error } = await fetchRiskalyzePortfolios();

          if (!error) {
            queryClient.invalidateQueries(modelsQueryKeys.modelGroups());

            if (firmSettingsAccess) {
              ADV.util.Router.go2('AdviserSettings', {
                page: 'ModelPortfolios',
              });
            }
          }
        }
      };

      if (riskalyzeOauthInterval == null) {
        riskalyzeOauthInterval = window.setInterval(longPoolPopupWindow, 300);
      }
    } catch (err) {
      console.error('Error connecting to Riskalyze:', err);
    }
  };

  return {
    ...importPortfoliosQueryInfo,
    ...connectRiskalyzeQuery,
    connectRiskalyze,
  };
};
